import { useEffect, useState } from 'react';

const OSLO_CENTER   = { lat: 59.9139, lng: 10.7522 };
const CACHE_KEY     = 'tippi_driver_location';

function readCache() {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
}

function writeCache(loc) {
  try { localStorage.setItem(CACHE_KEY, JSON.stringify(loc)); } catch {}
}

export function useDriverLocation() {
  const [location, setLocation]         = useState(() => readCache());
  const [locationError, setLocationError] = useState(null);
  // Sant når posisjonen ikke kunne hentes og vi ikke har noen tidligere posisjon å falle tilbake på
  const [usingFallback, setUsingFallback] = useState(false);

  useEffect(() => {
    if (!navigator.geolocation) {
      setLocationError('Nettleseren støtter ikke geolokalisering');
      if (!readCache()) { setLocation(OSLO_CENTER); setUsingFallback(true); }
      return;
    }

    const id = navigator.geolocation.watchPosition(
      (pos) => {
        const loc = { lat: pos.coords.latitude, lng: pos.coords.longitude };
        writeCache(loc);
        setLocation(loc);
        setLocationError(null);
        setUsingFallback(false);
      },
      (err) => {
        setLocationError(err.message);
        if (!readCache()) { setLocation(OSLO_CENTER); setUsingFallback(true); }
      },
      { enableHighAccuracy: true, timeout: 10000 }
    );

    return () => navigator.geolocation.clearWatch(id);
  }, []);

  return { location, locationError, usingFallback };
}
